module.exports = __webpack_public_path__ + "static/media/delete-x-primary.00ccded8.svg";